// Centralized graph serialization/deserialization utilities
// - Removes functions
// - Handles END_SCRIPT ↔ __end_script__ position key transform for Firestore compatibility

export const serializeScriptGraph = (scriptGraph) => {
  const serialized = JSON.parse(JSON.stringify(scriptGraph || {}));
    
  // Convert any function scripts to string representations
  Object.keys(serialized.nodes || {}).forEach(nodeId => {
    const node = serialized.nodes[nodeId];
    if (typeof node.script === 'function') {
      node.script = node.script.toString();
    }
  });
    
  // Firestore fix: __end_script__ is not allowed as a field
  if (serialized.ui?.positions && serialized.ui.positions['__end_script__']) {
    serialized.ui.positions['END_SCRIPT'] = serialized.ui.positions['__end_script__'];
    delete serialized.ui.positions['__end_script__'];
  }
    
  return serialized;
};

export const deserializeScriptGraph = (scriptGraph) => {
  const deserialized = JSON.parse(JSON.stringify(scriptGraph || {}));
    
  // SECURITY: Scripts are kept as strings only — no dynamic code execution.
  // Previously used new Function() which was a code injection vector.
  // Scripts stored in Firestore remain as string data.
    
  // Firestore fix: convert END_SCRIPT back to __end_script__
  if (deserialized.ui?.positions && deserialized.ui.positions['END_SCRIPT']) {
    deserialized.ui.positions['__end_script__'] = deserialized.ui.positions['END_SCRIPT'];
    delete deserialized.ui.positions['END_SCRIPT'];
  }
    
  return deserialized;
};

